import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../utils/axios/requestInfo";
import { api } from "../../../../resources/api";

export const fetchEditName = createAsyncThunk<number, { name: string }>(
  "editName/fetcheditName",
  async (data) => {
    try {
      const response = await axiosInstance.put(api.profile.settings.changeName.CHANGE_NAME, data);
      return response.status;
    } catch (error: any) {
      return error.response?.status || 500;
    }
  }
);

export const fetchEditEmail = createAsyncThunk<number, { email: string }>(
    "editEmail/fetchedEmail",
    async (data) => {
        try {
            const response = await axiosInstance.put(
                api.profile.settings.changeEmail.CHANGE_EMAIL,
                data
            );
            return response.status;
        } catch (error: any) {
            return error.response?.status || 500;
        }
    }
);

export const fetchEditPassword = createAsyncThunk<number, { password: string }>(
    "editPassword/fetchePass",
    async (data) => {
        try {
            const response = await axiosInstance.put(
                api.profile.settings.changePass.CHANGE_PASS,
                { password: data.password }
            );
            return response.status;
        } catch (error: any) {
            return error.response?.status || 500;
        }
    }
);

export const fetchSendPhoneCode = createAsyncThunk<number, { phone: string }>(
    "editPhone/fetchSendPhoneCode",
    async (data) => {
        try {
            const response = await axiosInstance.put(
                api.profile.settings.changeName.CHANGE_NAME,
                { phone: data.phone }
            );
            return response.status;
        } catch (error: any) {
            return error.response?.status || 500;
        }
    }
);

export const fetchEditPhone = createAsyncThunk<number, { phone: string, code: number }>(
    "editPhone/fetchedPhone",
    async (data) => {
        try {
            const response = await axiosInstance.post(
                api.profile.settings.changePhone.CHANGE_PHONE,
                {
                    phone: data.phone,
                    code: data.code,
                }
            );
            return response.status;
        } catch (error: any) {
            return error.response?.status || 500;
        }
    }
);